// Auth API response types
import { z } from "zod";
import { StandardResponseSchema, type StandardResponse } from "@/helpers/types";

// Verify free user response - uses StandardResponse { ok: boolean }
export const VerifyFreeUserResponseSchema = StandardResponseSchema;
export type VerifyFreeUserResponse = StandardResponse;

// Social (OAuth) signup: provision a tenant for the authenticated Google user.
// Email/name come from the verified session; only the instance name is sent.
export interface SocialRegisterRequest {
  company: string;
  newsletter?: boolean;
  first_name?: string;
  last_name?: string;
  source_insight?: string;
  // "Tell us about your setup" answers; stored in the user's attributes JSON.
  primary_warehouse?: string;
  role?: string;
}

// status: "ok" -> instance/api_url + a short-lived login_token the client
// exchanges for the session; "instance_taken" -> re-prompt. The raw api_key is
// never returned to the client.
export const SocialRegisterResponseSchema = z.object({
  status: z.string(),
  instance: z.string().nullable().optional(),
  api_url: z.string().nullable().optional(),
  login_token: z.string().nullable().optional(),
});
export type SocialRegisterResponse = z.infer<typeof SocialRegisterResponseSchema>;

// Login error response
export interface LoginErrorResponse {
  detail: string;
}

// Reset password request
export interface ResetPasswordRequest {
  password: string;
  token: string;
}

// Register invite request
export interface RegisterInviteRequest {
  name: string;
  password: string;
  token: string;
}

// Register SSO request
export interface RegisterSSORequest {
  firstName: string;
  lastName: string;
}

// Login request
export interface LoginRequest {
  email: string;
  password: string;
}

// Forgot password request
export interface ForgotPasswordRequest {
  email: string;
}
